<template>
  <div class="xy-container pageModule">
    <Title />
    <div ref="allList" class="list_content xy-scroll-col">
      <!-- <header v-show="!testunion">
        <div class="composite-box">
          <a-row type="flex">
            <a-col>
              <div class="composite-list">
                <ul>
                  <li
                    v-for="item in taskTitList"
                    :key="item.id"
                    :class="{ active: isActive === item.id }"
                    @click="tabClick(item.id)"
                  >
                    <span>{{ item.name }}</span>
                  </li>
                </ul>
              </div>
            </a-col>
          </a-row>
        </div>
      </header> -->
      <div v-if="listShow" class="content_div">
        <div v-if="isActive == 1" class="search_div">
          <span class="span">{{ $t('exam.year') }}：</span>
          <a-select
            v-model="form.schoolYear"
            class="select"
            placeholder="请选择学期学年"
            :get-popup-container="triggerNode => triggerNode.parentNode"
            @change="changeForm(true)"
          >
            <a-select-option
              v-for="(val, i) in schoolyearList"
              :key="i"
              :value="val.Id"
            >
              {{ val.Name }}
            </a-select-option>
          </a-select>
          <span class="span">{{ $t('exam.grade') }}：</span>
          <a-select
            v-model="form.gradeId"
            style="width: 120px"
            class="select"
            placeholder="请选择年级"
            :get-popup-container="triggerNode => triggerNode.parentNode"
            @change="changeForm(true)"
          >
            <a-select-option
              v-for="(val, i) in gradeList"
              :key="i"
              :value="val.gradeId"
            >
              {{ val.gradeName }}
            </a-select-option>
          </a-select>
          <span class="span">{{ $t('exam.examType') }}：</span>
          <a-select
            v-model="form.meExamType"
            style="width: 120px"
            class="select"
            placeholder="考试类型"
            :get-popup-container="triggerNode => triggerNode.parentNode"
            @change="changeForm(true)"
          >
            <a-select-option
              v-for="(val, i) in examTypeList"
              :key="i"
              :value="val.value"
            >
              {{ val.label }}
            </a-select-option>
          </a-select>
          <span class="span">{{ $t('exam.examName') }}：</span>
          <a-select
            v-model="form.examId"
            class="select"
            placeholder="考试名称"
            :get-popup-container="triggerNode => triggerNode.parentNode"
            @change="changeForm()"
          >
            <a-select-option
              v-for="(val, i) in examList"
              :key="i"
              :value="val.value"
              :title="val.label"
            >
              <span :title="val.lable">{{ val.lable }}</span>
            </a-select-option>
          </a-select>
        </div>
        <div v-else class="search_div">
          <span class="span">{{ $t('exam.examName') }}：</span>
          <a-select
            v-model="form.examId"
            class="select"
            placeholder="考试名称"
            :get-popup-container="triggerNode => triggerNode.parentNode"
            @change="changeForm()"
          >
            <a-select-option
              v-for="(val, i) in examList"
              :key="i"
              :value="val.value"
              :title="val.label"
            >
              <span :title="val.lable">{{ val.lable }}</span>
            </a-select-option>
          </a-select>
        </div>
        <div
          v-if="examInfoList && !examInfoList.length"
          class="not_div"
          style="height: 100%"
        >
          <NotData>
            <template #msg>
              {{ notDataMsg }}
            </template>
          </NotData>
        </div>
        <div class="content-card">
          <template>
            <div v-for="item in examInfoList" :key="item.id" class="test_line">
              <div class="type_shoole">
                <div class="exam_type">
                  <div class="exam_type_img">
                    <img :src="item.img" alt="" />
                  </div>
                </div>
                <div class="exam_text">
                  <div class="line_msg" style="margin-top: 15px">
                    <a-tag class="tag">
                      {{
                        !testunion && isActive == 1
                          ? `${item.enterYear || '--'}${$t('exam.ji')}`
                          : compGrade(item.gradeId)
                      }}
                    </a-tag>
                    <span class="title_exam">
                      {{ `【${item.type}】${item.name}` }}
                    </span>
                    <a-divider type="vertical" />
                    <span class="showDown" @click="get_exam_groud(item)">
                      {{
                        item.showgroup ? $t('exam.shouqi') : $t('exam.zhankai')
                      }}
                      <a-icon :type="item.showgroup ? 'up' : 'down'" />
                    </span>
                  </div>
                  <div class="line_msg">
                    <span class="exam_time">
                      {{ $t('exam.examTime') }}: {{ item.examTime || '--' }}
                    </span>
                    <a-divider type="vertical" />
                    <span>
                      {{ $t('exam.unPuSub') }}:{{
                        item.unPublishedCourse.map(ele => ele.name).join(',') ||
                        '--'
                      }}
                    </span>
                  </div>
                </div>
                <a-row class="action">
                  <a-col>
                    <a-button
                      class="clear"
                      type="danger"
                      ghost
                      @click="clearReport(item)"
                    >
                      {{ $t('exam.clear') }}
                    </a-button>

                    <span v-if="testunion">
                      {{ $t('exam.isSchool') }}
                      <a-switch
                        :checked="Boolean(item.isSchoolSwitch)"
                        style="margin-right: 15px"
                        @change="updateUnionSwitch(item, 1)"
                      />
                    </span>

                    <span v-if="testunion" style="margin-right: 15px">
                      <span
                        :style="
                          !item.isSchoolSwitch && { visibility: 'hidden' }
                        "
                      >
                        {{ $t('exam.isRank') }}
                        <a-switch
                          :checked="Boolean(item.isRankSwitch)"
                          @change="updateUnionSwitch(item, 2)"
                        />
                      </span>
                    </span>
                    <div
                      v-if="(isShowToParent || isShowToStudent) && !testunion"
                    >
                      <p v-if="isShowToParent" class="line_p">
                        {{ $t('exam.isParent') }}
                        <a-switch
                          :checked="Boolean(item.isSwitch)"
                          @change="updateSwitch(item)"
                        />
                      </p>
                      <p
                        v-if="isShowToStudent && isActive == 1"
                        class="line_p"
                        style="color: #a78bfa"
                        @click="toShowStudent(item)"
                      >
                        <img
                          src="./img/link.png"
                          style="width: 20px; height: 20px"
                        />
                        {{ $t('exam.isStudent') }}
                      </p>
                    </div>
                    <div class="down_title style-report-btn">
                      <span
                        v-if="
                          item.publishedCourse && item.publishedCourse.length
                        "
                      >
                        <a-divider
                          v-if="
                            (isShowToParent || isShowToStudent) && !testunion
                          "
                          type="vertical"
                        />
                        <a-dropdown
                          :get-popup-container="
                            triggerNode => triggerNode.parentNode
                          "
                        >
                          <a-menu
                            slot="overlay"
                            style="maxheight: 200px; overflow: auto"
                          >
                            <a-menu-item
                              v-for="(son, index) in item.publishedCourse"
                              :key="index"
                              class="son_item"
                              @click="selectDown(son)"
                            >
                              {{ son.name }}
                            </a-menu-item>
                          </a-menu>
                          <span class="down-menu">
                            {{ $t('exam.downAll') }} <a-icon type="down" />
                          </span>
                        </a-dropdown>
                      </span>
                      <span
                        v-if="
                          !testunion &&
                          isActive == 1 &&
                          item.downList &&
                          item.downList.length &&
                          item.downList.length == 1 &&
                          !item.downList[0].groupId
                        "
                      >
                        <a-divider type="vertical" />
                        <a-dropdown
                          :get-popup-container="
                            triggerNode => triggerNode.parentNode
                          "
                        >
                          <a-menu
                            slot="overlay"
                            style="maxheight: 200px; overflow: auto"
                          >
                            <a-menu-item
                              v-for="(son, index) in getNewList(item)"
                              :key="index"
                              class="son_item"
                              @click="groupDown(son, 0)"
                            >
                              {{ son.name }}
                            </a-menu-item>
                          </a-menu>
                          <span class="down-menu">
                            {{ $t('exam.downOne') }} <a-icon type="down" />
                          </span>
                        </a-dropdown>
                      </span>
                    </div>
                    <a-button
                      v-if="
                        item.downList.length == 1 &&
                        item.downList[0].groupId == 0
                      "
                      type="primary"
                      class="style-report-btn"
                      @click="dataContrast(item, 0)"
                    >
                      {{ $t('exam.comparison') }}
                    </a-button>
                    <a-button
                      v-if="isActive == 1"
                      v-schoolPermissions="[30, 218, 136]"
                      type="primary"
                      class="style-report-btn"
                      @click="personalizedReport(item)"
                    >
                      {{ $t('exam.downSelf') }}
                    </a-button>
                  </a-col>
                </a-row>
              </div>
              <a-card
                :class="['groudsname', { topline: item.showgroup }]"
                :loading="item.loading"
              >
                <div
                  :class="['parsing', { parsingShow: item.showgroup }]"
                  :style="item.maxHeight"
                >
                  <div
                    v-for="groud in item.downList"
                    :key="groud.groupId"
                    class="sun_item"
                  >
                    <div
                      v-if="
                        Boolean(groud.groupId) && groud.examGroupInfoList.length
                      "
                      class="groud_name"
                    >
                      {{ groud.groupName }}
                      <span v-if="!testunion && isActive == 1">
                        <a-divider type="vertical" />
                        <a-dropdown
                          :get-popup-container="
                            triggerNode => triggerNode.parentNode
                          "
                        >
                          <a-menu
                            slot="overlay"
                            style="maxheight: 200px; overflow: auto"
                          >
                            <a-menu-item
                              v-for="(son, index) in getNewList(item, groud)"
                              :key="index"
                              class="son_item"
                              @click="groupDown(son, groud.groupId)"
                            >
                              {{ son.name }}
                            </a-menu-item>
                          </a-menu>
                          <span class="down-menu">
                            {{ $t('exam.downOne') }} <a-icon type="down" />
                          </span>
                        </a-dropdown>
                      </span>
                      <a-button
                        v-if="!testunion && isActive == 1"
                        type="primary"
                        size="small"
                        style="margin-left: 20px"
                        @click="dataContrast(item, groud.groupId)"
                      >
                        {{ $t('exam.comparison') }}
                      </a-button>
                    </div>
                    <a-row
                      v-for="subject in groud.examGroupInfoList"
                      :key="subject.seId"
                      type="flex"
                      justify="space-between"
                      class="sun_item_line"
                    >
                      <a-col :span="2">
                        <div
                          :class="[
                            'subject_name',
                            { onesubject: subject.seId }
                          ]"
                          @click="toPath(subject, item)"
                        >
                          {{ subject.name }}
                        </div>
                      </a-col>
                      <a-col :span="2">
                        <div class="number_msg">
                          {{ subject.studentCount }}
                        </div>
                        <div class="text_msg">
                          {{ $t('exam.studentCount') }}
                        </div>
                      </a-col>
                      <a-col :span="2">
                        <div class="number_msg">
                          {{ subject.totalScore }}
                        </div>
                        <div class="text_msg">{{ $t('exam.totalScore') }}</div>
                      </a-col>
                      <a-col :span="2">
                        <div class="number_msg">
                          {{ subject.avgScore }}
                        </div>
                        <div class="text_msg">{{ $t('exam.avgScore') }}</div>
                      </a-col>
                      <a-col :span="2">
                        <div class="number_msg">
                          {{ subject.maxScore }}
                        </div>
                        <div class="text_msg">{{ $t('exam.maxScore') }}</div>
                      </a-col>
                      <a-col :span="2">
                        <div class="number_msg red">
                          {{ subject.minScore }}
                        </div>
                        <div class="text_msg">{{ $t('exam.minScore') }}</div>
                      </a-col>

                      <a-col :span="2">
                        <div class="number_msg">
                          {{ subject.overAverageRate }}
                        </div>
                        <div class="text_msg">
                          {{ $t('exam.overAverageRate') }}
                        </div>
                      </a-col>
                      <a-col :span="2">
                        <div class="number_msg">
                          {{ subject.overAverageNumber }}
                        </div>
                        <div class="text_msg">
                          {{ $t('exam.overAverageNumber') }}
                        </div>
                      </a-col>
                      <a-col :span="2">
                        <div :class="['number_msg', { red: subject.seId }]">
                          {{ subject.seId ? subject.standardDeviation : '--' }}
                        </div>
                        <div class="text_msg">
                          {{ $t('exam.standardDeviation') }}
                        </div>
                      </a-col>
                      <a-col :span="2">
                        <div :class="['number_msg', { red: subject.seId }]">
                          {{ subject.seId ? subject.difficulty : '--' }}
                        </div>
                        <div class="text_msg">{{ $t('exam.difficulty') }}</div>
                      </a-col>
                      <a-col :span="2">
                        <div :class="['number_msg', { red: subject.seId }]">
                          {{ subject.seId ? subject.discrimination : '--' }}
                        </div>
                        <div class="text_msg">
                          {{ $t('exam.discrimination') }}
                        </div>
                      </a-col>
                    </a-row>
                  </div>
                </div>
              </a-card>
            </div>
          </template>
        </div>
      </div>
      <Backtop :data-ele="dataEle" />
    </div>

    <a-modal
      :visible="isDataContrastShow"
      centered
      width="875px"
      wrap-class-name="content_modal"
      :destroy-on-close="true"
      class="uploadModal"
      :title="$t('exam.discrimination')"
      @cancel="cancelCopy"
      @ok="okCopy"
    >
      <!-- <div>
        <div style="height: 588px; overflow-y: auto">111</div>
      </div> -->

      <a-form-model
        id="idContrastForm"
        ref="contrastForm"
        class="contrast-form"
        :model="contrastForm"
        :rules="contrastRules"
        :label-col="{ span: 3 }"
        :wrapper-col="{ span: 19 }"
      >
        <a-form-model-item
          ref="examName"
          :label="$t('exam.testName')"
          prop="examName"
        >
          <span>
            {{ examName }}
          </span>
        </a-form-model-item>
        <a-form-model-item
          ref="directExam"
          :label="$t('exam.derectTest')"
          prop="directExam"
        >
          <div>
            {{ $t('exam.derectTip') }}
          </div>
          <a-tree-select
            v-model="contrastForm.directExam"
            style="width: 100%"
            :tree-data="directTreeData"
            tree-node-label-prop="label"
            :get-popup-container="triggerNode => triggerNode.parentNode"
            :placeholder="$t('exam.placeholder1')"
          />
          <!-- directTreeData -->
        </a-form-model-item>
        <a-form-model-item
          ref="studentCode"
          :label="
            testunion || isActive == 2
              ? '间接对比考试'
              : $t('exam.inderectTest')
          "
          prop="studentCode"
        >
          <div>
            {{ $t('exam.inderectTip') }}
          </div>
          <!-- tree-checkable -->
          <!-- tree-node-label-prop="labelName" -->
          <a-tree-select
            v-model="indirectExam"
            style="width: 100%"
            :tree-data="indirectTreeData"
            tree-checkable
            :show-checked-strategy="SHOW_PARENT"
            tree-node-label-prop="label"
            :get-popup-container="triggerNode => triggerNode.parentNode"
            :dropdown-style="{ maxHeight: '400px', overflow: 'auto' }"
            :placeholder="$t('exam.placeholder2')"
            @change="onIndirectSelect"
          />
          <!-- <a-icon class="exam-b-icon" type="down" :rotate="rotateIcon" /> -->
        </a-form-model-item>
      </a-form-model>
    </a-modal>
    <a-modal
      :visible="!!showStudent"
      centered
      width="540px"
      wrap-class-name="content_modal"
      :destroy-on-close="true"
      class="search_score"
      :title="$t('exam.studentTitle')"
      @cancel="showStudent = null"
    >
      <div>
        <a-row
          :class="[
            'line_item',
            { noBorder_item: !Boolean(showStudent?.VisibleToStudent) }
          ]"
        >
          <a-col :span="20">
            <p class="title_text">{{ $t('exam.studentCan') }}</p>
            <p class="msg_text">
              {{ $t('exam.studentCanTip') }}
            </p>
          </a-col>
          <a-col :span="4" class="col_right">
            <a-switch
              :checked="Boolean(showStudent?.VisibleToStudent)"
              @change="updatestudentvisiblestatus"
            />
          </a-col>
        </a-row>
        <template v-if="Boolean(showStudent?.VisibleToStudent)">
          <a-row class="line_item" style="line-height: 50px">
            <a-col :span="15" class="title_text">{{ $t('exam.lang') }}</a-col>
            <a-col :span="9" class="col_right">
              <a-radio-group v-model="lang_value">
                <a-radio :value="1"> {{ $t('exam.langList[0]') }} </a-radio>
                <a-radio :value="2"> {{ $t('exam.langList[1]') }} </a-radio>
              </a-radio-group>
            </a-col>
          </a-row>
          <a-row style="line-height: 50px; border: none">
            <a-col :span="15" class="title_text">
              {{ $t('exam.searchLink') }}
            </a-col>
            <a-col :span="9" class="col_right copy" @click="copyText(copyurl)">
              <img src="./img/copy.png" style="width: 20px; height: 20px" />
              {{ $t('exam.copy') }}
            </a-col>
          </a-row>
          <a-row class="link_conten">
            {{ copyurl }}
          </a-row>
        </template>
      </div>
      <template slot="footer">
        <a-button type="primary" @click="showStudent = null">
          {{ $t('common.modal.cancelTaxtClose') }}
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
  import axios, { Toast, getUser, getStore } from '@/utils'
  import { downFilter } from '@xy/utils'

  import ApiXy from '@/lib/api.js'
  import { TreeSelect } from 'ant-design-vue'
  const SHOW_PARENT = TreeSelect.SHOW_PARENT

  export default {
    name: '',
    data() {
      return {
        rotateIcon: 0,
        lang_value: 1,
        schoolId: '',
        addListCopy: [],
        examGroup: '',
        groupId: 0,
        examName: '',
        addList: [],
        SHOW_PARENT,
        pval: '',
        isDataContrastShow: false,
        contrastForm: {
          directExam: null
        },
        contrastRules: {
          directExam: [
            {
              required: true,
              message: this.$t('exam.placeholder1'),
              trigger: 'change'
            }
          ]
        },
        directTreeData: [],
        indirectTreeData: [],
        indirectExam: null,
        testunion: true, // 校端还是区端
        isActive: this.$store.state.examIsActive, // 当前选中的tab
        taskTitList: [
          {
            id: 1,
            name: this.$t('exam.taskTitList[0]')
          },
          {
            id: 2,
            name: this.$t('exam.taskTitList[1]')
          }
        ],
        dataEle: null,
        itemData: null,
        modalTitle: '',
        meId: '',
        examInfo: [],

        ids: [],
        courseList: [],
        tagList: [],
        // subjectNames: '',
        openTactic: false,
        actIndex: 0, //当前选中的科目的下表
        courseId: 0, //保存id
        examId: 0, //科目id
        tacTicData: [],
        showsubject: false,
        dynamicValidateForm: {
          domains: []
        },
        confirmLoading: false,
        schoolyearList: [],
        form: {
          schoolYear: '', //学年学期
          gradeId: -1, //年级
          examId: 0, //考试名称
          meType: -1, //文理分科
          meExamType: -1 //考试类型
        },
        examTypeList: [
          {
            label: this.$t('exam.examTypeList[0]'),
            value: -1
          },
          { label: this.$t('exam.examTypeList[1]'), value: '0' },
          { label: this.$t('exam.examTypeList[2]'), value: '1' },
          { label: this.$t('exam.examTypeList[3]'), value: '2' },
          { label: this.$t('exam.examTypeList[4]'), value: '3' },
          { label: this.$t('exam.examTypeList[5]'), value: '4' },
          { label: this.$t('exam.examTypeList[6]'), value: '5' }
        ],
        meTypeList: [
          { label: this.$t('exam.meTypeList[0]'), value: -1 },
          { label: this.$t('exam.meTypeList[1]'), value: 0 },
          { label: this.$t('exam.meTypeList[2]'), value: 1 },
          { label: this.$t('exam.meTypeList[3]'), value: 2 }
        ],
        gradeList: [
          {
            gradeId: -1,
            gradeName: this.$t('exam.gradeList[0]')
          }
        ],
        examList: [{ label: this.$t('exam.examList[0]'), value: 0 }],
        examInfoList: undefined,
        totalStatus: false,
        stageType: '',
        listShow: true,
        bureauId: null,
        isShowToParent: 0, //是否显示家长可见 0不显示1显示
        isShowToStudent: 0, //是否显示家长可见 0不显示1显示
        showStudent: null, //是否显示弹框
        defultMsg: this.$t('common.filternotData'),
        notDataMsg: this.$t('common.filternotData'),
        examGradeList: [
          {
            gradeId: 101,
            gradeName: this.$t('exam.examGradeList[0]'),
            stageType: 2
          },
          {
            gradeId: 102,
            gradeName: this.$t('exam.examGradeList[1]'),
            stageType: 2
          },
          {
            gradeId: 103,
            gradeName: this.$t('exam.examGradeList[2]'),
            stageType: 2
          },
          {
            gradeId: 104,
            gradeName: this.$t('exam.examGradeList[3]'),
            stageType: 2
          },
          {
            gradeId: 105,
            gradeName: this.$t('exam.examGradeList[4]'),
            stageType: 2
          },
          {
            gradeId: 106,
            gradeName: this.$t('exam.examGradeList[5]'),
            stageType: 2
          },
          {
            gradeId: 201,
            gradeName: this.$t('exam.examGradeList[6]'),
            stageType: 3
          },
          {
            gradeId: 202,
            gradeName: this.$t('exam.examGradeList[7]'),
            stageType: 3
          },
          {
            gradeId: 203,
            gradeName: this.$t('exam.examGradeList[8]'),
            stageType: 3
          },
          {
            gradeId: 301,
            gradeName: this.$t('exam.examGradeList[9]'),
            stageType: 4
          },
          {
            gradeId: 302,
            gradeName: this.$t('exam.examGradeList[10]'),
            stageType: 4
          },
          {
            gradeId: 303,
            gradeName: this.$t('exam.examGradeList[11]'),
            stageType: 4
          }
        ]
      }
    },
    computed: {
      copyurl() {
        return `https://check.xycxedu.${process.env.VUE_APP_ENV}/searchSore?lang=${this.lang_value}&meId=${this.showStudent?.meId}&schoolId=${this.schoolId}`
      }
    },
    created() {
      // const locale = getStore('locale')
      // if (!locale) {
      //   setStore('locale', 'zh')
      // }
    },
    async mounted() {
      this.dataEle = this.$refs.allList
      let { data } = await getUser()
      let { role, bureauId, schoolId } = data
      this.testunion = role === 6 ? true : false
      this.bureauId = bureauId
      this.schoolId = schoolId
      this.tabClick()
    },
    methods: {
      copyText(val) {
        const textArea = document.createElement('textArea')
        textArea.value = val
        document.body.appendChild(textArea)
        textArea.select()
        document.execCommand('copy')
        document.body.removeChild(textArea)
        Toast.success(this.$t('exam.copysucess'))
      },

      toShowStudent(item) {
        console.log(item)
        this.showStudent = item
      },
      // 联考年级回显
      compGrade(id) {
        let arr = this.examGradeList.filter(item => item.gradeId == id)
        return arr.length ? arr[0].gradeName : '--'
      },
      // 改变联考学校可见和排名可见
      updateUnionSwitch(item, type) {
        let { meId } = item

        let key = type == 1 ? 'isSchoolSwitch' : 'isRankSwitch'

        let isSwitch = item[key] ? 0 : 1

        axios({
          url: 'updatesUnionStatus',
          loading: true,
          type: 'post',
          data: {
            meId,
            type,
            isSwitch
          }
        }).then(res => {
          if (res.status) {
            item[key] = item[key] ? 0 : 1
            if (type == 1 && !isSwitch) {
              item['isRankSwitch'] = 0
            }
            Toast.success(this.$t('exam.ztsucess'))
          }
        })
      },

      updatestudentvisiblestatus(type) {
        let { meId: MeID } = this.showStudent

        let IsVisible = type ? 1 : 0

        axios({
          url: 'updatestudentvisiblestatus',
          type: 'post',
          params: {
            MeID,
            IsVisible
          }
        }).then(res => {
          if (res.status) {
            this.showStudent.VisibleToStudent = IsVisible
            Toast.success(this.$t('exam.sucess'))
          }
        })
      },
      // 清理报表缓存
      clearReport(item) {
        let { meId } = item
        let type = this.testunion ? 1 : 2
        if (this.isActive == 1) {
          type = 3
        }
        axios({
          host: 'testApi',
          url: 'delreportcache',
          loading: true,
          type: 'get',
          params: {
            meId,
            type
          }
        }).then(res => {
          if (res.status) {
            Toast.success(this.$t('exam.hcsucess'))
          }
        })
      },

      // 数据对比
      dataContrast(val, groud) {
        console.log(val)
        // 直接对比考试
        this.contrastForm.directExam = null
        // 间接对比考试
        this.indirectExam = null

        this.examGroup = val
        this.groupId = groud
        this.examName = val.name
        this.getDirectExam(val)
        this.getIndirectExam(val)
        this.isDataContrastShow = true
      },
      // 获取直接 --- 考试数据
      getDirectExam(val) {
        let params = {}
        params = {
          meId: val.meId,
          groupId: this.groupId,
          type: 1
        }

        let url =
          this.testunion || this.isActive == 2
            ? 'unionexamcomparison'
            : 'getExamcomparison'
        //  如果是联考
        if (url == 'unionexamcomparison') {
          params.isUnion = this.testunion ? 1 : 0
        }

        axios({
          url,
          loading: true,
          params
        }).then(res => {
          if (res.status) {
            let arr = res.data
            if (arr != null) {
              this.directTreeData = arr.map(item => {
                item.title = item.MeName
                item.label = item.MeName
                item.value = item.MeId
                item.key = item.MeId
                item.selectable = false
                item.checkable = false
                item.children = item.GroupInfo == null ? [] : item.GroupInfo
                if (item.children) {
                  item.children = item.children.map(son => {
                    son.title = son.Name //  + '-' + item.MeId + son.Id
                    son.label =
                      item.MeName + (son.Id == 0 ? '' : '-' + son.Name)

                    son.value = item.MeId.toString() + son.Id.toString()
                    son.key = item.MeId.toString() + son.Id.toString()
                    son.pvalue = son.PId
                    son.mePId = item.MeId
                    son.meDate = item.MeDate
                    son.checkable = false
                    // son.checkable = son.IsCheck
                    return son
                  })
                }
                return item
              })
              // 数据回显
              let directExam = null
              this.directTreeData.forEach(item => {
                if (item.IsCheck) {
                  item.children.forEach(cit => {
                    if (cit.IsCheck) {
                      directExam = cit.value
                    }
                  })
                }
              })
              this.contrastForm.directExam = directExam
            } else {
              this.directTreeData = []
              this.contrastForm.directExam = null
            }
          }
        })
      },
      // 获取间接 --- 考试数据
      getIndirectExam(val) {
        let params = {}
        params = {
          meId: val.meId,
          groupId: this.groupId,
          type: 2
        }

        let url =
          this.testunion || this.isActive == 2
            ? 'unionexamcomparison'
            : 'getExamcomparison'
        //  如果是联考
        if (url == 'unionexamcomparison') {
          params.isUnion = this.testunion ? 1 : 0
        }
        axios({
          url,
          loading: true,
          params
        }).then(res => {
          if (res.status) {
            let arr = res.data
            if (arr != null) {
              this.indirectTreeData = arr.map(item => {
                item.title = item.MeName
                item.label = item.MeName
                item.value = item.MeId
                item.key = item.MeId
                item.selectable = false
                item.checkable = false
                item.children = item.GroupInfo == null ? [] : item.GroupInfo
                if (item.children) {
                  item.children = item.children.map(son => {
                    son.title = son.Name // + '-' + item.MeId + son.Id
                    // son.label = item.MeName + '-' + son.Name
                    son.label =
                      item.MeName + (son.Id == 0 ? '' : '-' + son.Name)
                    son.value = item.MeId.toString() + son.Id.toString()
                    son.key = item.MeId.toString() + son.Id.toString()
                    son.sonId = son.Id
                    son.pvalue = son.PId
                    son.mePId = item.MeId
                    son.meDate = item.MeDate
                    son.checkable = true
                    // son.checkable = son.IsCheck
                    son.disabled = false
                    return son
                  })
                }
                return item
              })
              // 数据回显
              let indirectExam = []
              this.indirectTreeData.forEach(item => {
                if (item.IsCheck) {
                  item.children.forEach(cit => {
                    if (cit.IsCheck) {
                      indirectExam.push(cit.value)
                    } else {
                      cit.disabled = true
                    }
                  })
                }
              })
              this.indirectExam = indirectExam

              let addListCopy = []
              indirectExam.forEach(item => {
                addListCopy.push(item)
              })
              this.addListCopy = addListCopy

              console.log('indirectExam', this.indirectExam)
            } else {
              this.indirectTreeData = []
              this.indirectExam = null
            }
          }
        })
      },
      // 间接对比考试 --- 选择
      onIndirectSelect(value, label, extra) {
        console.log(value, label)
        if (this.indirectExam.length > 2) {
          this.indirectExam.pop()
          return Toast.fail(this.$t('exam.directExam'))
        }
        // 当前节点是否选中
        if (
          extra.triggerNode.checked ||
          extra.triggerNode.checked === undefined ||
          !extra
        ) {
          this.addList =
            this.addList.length == 0 ? this.addListCopy : this.addList
          // 取两个数组之间的差
          let cList = this.addList.filter(x => !value.includes(x))
          let cListItem = cList[0]

          // 获取选中的父节点
          this.indirectTreeData.forEach(pitem => {
            if (pitem.children.length > 0) {
              pitem.children.forEach(ic => {
                if (ic.value == cListItem) {
                  this.pval = ic.mePId //  pvalue
                }
              })
            }
          })
          // value children
          if (value.length > 0) {
            this.indirectTreeData.forEach(item => {
              if (item.children.length > 0) {
                item.children.forEach(ic => {
                  if (ic.mePId == this.pval) {
                    ic.disabled = false
                  }
                })
              }
            })
          } else {
            this.indirectTreeData.forEach(item => {
              if (item.children.length > 0) {
                item.children.forEach(ic => {
                  ic.disabled = false
                })
              }
            })
          }
        } else {
          let list = []
          if (value.length > 0) {
            value.forEach(ctem => {
              list.push(ctem)
            })
          }
          this.addList = list
          let lastVal = value[value.length - 1]
          lastVal = parseInt(lastVal)
          // 获取选中的父节点
          this.indirectTreeData.forEach(pitem => {
            if (pitem.children != null || pitem.children.length > 0) {
              pitem.children.forEach(ic => {
                if (parseInt(ic.value) == lastVal) {
                  this.pval = ic.mePId
                }
              })
            }
          })
          // value children
          this.indirectTreeData.forEach(item => {
            if (item.children != null || item.children.length > 0) {
              item.children.forEach(ic => {
                ic.labelName = item.title + '-' + ic.title
                if (ic.mePId == this.pval && parseInt(ic.value) != lastVal) {
                  ic.disabled = true
                }
                if (ic.mePId == this.pval && parseInt(ic.value) == lastVal) {
                  ic.disabled = false
                }
              })
            }
          })
        }
      },
      // 数据对比 --- 取消
      cancelCopy() {
        this.isDataContrastShow = false
      },
      // 数据对比 --- 确定
      okCopy() {
        this.$refs.contrastForm.validate(valid => {
          if (valid) {
            this.confirmLoading = true
            // 创建数据
            let data
            data = {
              targetMeId: this.examGroup.meId,
              targetGroupId: this.groupId,
              examGroupInfo: []
            }

            // 直接对比考试 ----------------------
            let directitem = ''
            this.directTreeData.forEach(item => {
              if (item.children.length > 0) {
                item.children.forEach(cit => {
                  if (parseInt(cit.value) == this.contrastForm.directExam) {
                    directitem = cit
                  }
                })
              }
            })
            let itemd = {
              meDate: '',
              groupId: '',
              meId: '',
              type: ''
              // id: ''
            }
            itemd.meDate = directitem.meDate
            itemd.groupId = directitem.Id
            itemd.meId = directitem.mePId
            itemd.type = 1
            // itemd.id = directitem.ComparisonKeyId
            data.examGroupInfo.push(itemd)
            // 间接对比考试 ----------------------
            if (this.indirectExam.length > 0) {
              // 有选择间接对比
              let arr = []
              this.indirectTreeData.forEach(item => {
                if (item.children.length > 0) {
                  item.children.forEach(ci => {
                    this.indirectExam.forEach(din => {
                      if (ci.value == din) {
                        arr.push({
                          meDate: ci.meDate,
                          groupId: ci.Id,
                          meId: ci.mePId,
                          // id: ci.ComparisonKeyId,
                          type: 2
                        })
                      }
                    })
                  })
                }
              })
              arr.forEach(item => {
                data.examGroupInfo.push(item)
              })
            }

            let url =
              this.testunion || this.isActive == 2
                ? 'saveunionexamcomparison'
                : 'saveexamcomparison'
            //  如果是联考
            if (url == 'saveunionexamcomparison') {
              data.isUnion = this.testunion ? 1 : 0
            }

            axios({
              url,
              type: 'post',
              data
            })
              .then(res => {
                if (res.status) {
                  Toast.success(res.msg)
                  this.isDataContrastShow = false
                  this.confirmLoading = false
                }
              })
              .catch(() => {
                setTimeout(() => {
                  this.confirmLoading = false
                }, 1000)
              })
          } else {
            return false
          }
        })
      },

      tabClick(index = this.isActive) {
        this.isActive = index // 1 = 校考考试, 2 = 联考考试
        this.$store.state.examIsActive = this.isActive
        this.listShow = false
        this.form.examId = 0
        this.getUser(index)
        if (!this.testunion) this.getisParentData()
      },
      changeForm(type) {
        if (type) {
          this.examList = [{ label: this.$t('exam.examList[0]'), value: 0 }]
          this.examId = 0
          this.getExamlist()
          this.getListcontent()
        }
        if (!type) {
          if (this.isActive === 1) {
            this.getListcontent()
          } else {
            this.getUnionListcontent()
          }
        }
      },
      updateSwitch(item) {
        let { meId, isSwitch } = item
        let index = 0
        if (this.isActive === 2) {
          index = this.testunion ? 2 : 1
        }
        let path = ['updateswitchstatus', 'updateUnionSwitch', '']
        axios({
          url: path[index],
          loading: true,
          type: 'post',
          data: {
            meId,
            isSwitch: +!isSwitch
          }
        }).then(res => {
          if (res.status) {
            item.isSwitch = +!isSwitch
            Toast.success(this.$t('exam.ztsucess'))
          }
        })
      },
      async get_exam_groud(item) {
        let index = 0
        if (this.isActive == 2) {
          index = this.testunion ? 1 : 2
        }
        // 0 是校级普通列表 1 是 区域联考列表 2 是 校级联考列表
        let paths = [
          'getreportexamgroupinfolist',
          'getexaminfochildlist',
          'getschoolexaminfochildlist'
        ]
        //  如果已经有组了
        if (item.showgroup) {
          item.loading = false
          item.showgroup = false
          item.downList = []
          return
        }
        item.showgroup = true
        let params = { meId: item.meId }

        if (index === 2) {
          let { data } = await getUser()
          let { schoolId } = data
          params.schoolId = schoolId
        }
        let timeId = setTimeout(() => {
          item.loading = true
        }, 400)
        axios({
          url: paths[index],
          params
        }).then(res => {
          if (res.status) {
            clearTimeout(timeId)
            item.loading = false
            item.downList = res.data || []
            // 展开不做更新 （有权限问题，过滤不准确）
            // this.updateListcontent(item)
            let height = res.data.length * 25 + 70
            res.data.forEach(item => {
              item.examGroupInfoList = item.examGroupInfoList || []
              let length = item.examGroupInfoList.length

              height += length * 80
            })
            item.maxHeight = {
              'max-height': height + 'px'
            }
          }
        })
      },
      toPath(info, examInfo) {
        let index = 0
        if (this.isActive == 2) {
          index = this.testunion ? 1 : 2
        }
        // 0 是校级普通列表 1 是 区域联考列表 2 是 校级联考列表
        let schoolYear = this.form.schoolYear
        let query = {
          seId: info.seId,
          meId: info.meId,
          subjectId: info.seCourseId,
          // type: examInfo.meExamType,
          dId: info.groupId, // 组id
          classId: 0,
          authId: 0,
          bureauId: info.bureauId,
          schoolYear,
          GradeId: examInfo.GradeId,
          seName: examInfo.name,
          schoolId: this.userInfo.schoolId,
          schoolIcon: getStore('userInfo').schoolIcon,
          sourceFrom: examInfo.sourceFrom || 0,
          examIsActive: index,
          locale: getStore('locale') || 'zh'
        }
        let url = `/singleReport${index == 1 ? 'union' : ''}`
        if (info.seId === 0) {
          if (examInfo.unPublishedCourse.length) {
            return Toast.fail(this.$t('exam.unallcourse'))
          }
          url = `/totalReport${index == 1 ? 'union' : ''}`
        }
        let str = url + '?'
        for (var k in query) {
          str += k + '=' + query[k] + '&'
        }
        if (process.env.NODE_ENV == 'development') {
          window.open('http://chris.xincuicy.com:8085' + str, '_blank')
        } else {
          window.open(process.env.VUE_APP_datacenter + str, '_blank')
        }
      },

      personalizedReport(item) {
        let { seId = 0, meId } = item
        axios({
          url: 'getreportinfo',
          loading: true,
          params: {
            meId,
            seId,
            reportCode: 'multiexamscore'
          }
        }).then(res => {
          if (res.status) {
            downFilter(ApiXy.defaulteApi.host + res.data.reportUrl)
            // window.open(res.data.reportUrl + `?t=${t}`, '_blank', '')
          }
        })
      },
      // 新接口（不要删）
      selectDown(son) {
        let { seId, meId } = son
        let params = {
          meId: meId,
          seId: seId || 0
        }
        // 校考
        let url = seId ? 'exportsinglereport' : 'exportmultireport'
        // 联考
        if (this.testunion || this.isActive == 2) {
          url = seId ? 'unionexportsinglereport' : 'unionexportmultireport'
          params.type = this.testunion ? 1 : 2
        }
        axios({
          url,
          loading: true,
          params
        }).then(res => {
          if (res.status) {
            downFilter(
              ApiXy.defaulteApi.host + res.data.reportUrl,
              res.data.reportName
            )
          }
        })
      },
      getNewList(item, groud) {
        let obj = groud || item.downList[0]
        obj.examGroupInfoList = obj.examGroupInfoList || []
        let list =
          item.unPublishedCourse && item.unPublishedCourse.length
            ? obj.examGroupInfoList.filter(ele => ele.seId)
            : obj.examGroupInfoList
        return list
      },
      // 分组，独立分析下载
      groupDown(son, groupId) {
        let { seId, meId, seCourseId: subjectId } = son
        let params = {
          meId: meId,
          seId: seId || 0,
          dId: groupId,
          subjectId
        }
        // 校考
        let url = seId
          ? 'exportindependentsinglereport'
          : 'exportindependentmultireport'
        // 联考
        // if (this.testunion || this.isActive == 2) {
        //   url = seId ? 'unionexportsinglereport2' : 'unionexportmultireport2'
        //   params.type = this.testunion ? 1 : 2
        // }
        axios({
          url,
          params,
          responseType: 'blob',
          loading: true
        }).then(res => {
          // 下载失败
          if (res.data.type == 'application/json') {
            var reader = new FileReader()
            reader.readAsText(res.data)
            reader.onload = () => {
              const jsonData = JSON.parse(reader.result)
              Toast.fail(jsonData.msg || this.$t('exam.doenFail'))
            }
            return
          }
          let temp =
            res.headers['content-disposition'].split('filename*=utf-8')[1]
          let fileName = decodeURIComponent(temp)
          const url = window.URL.createObjectURL(new Blob([res.data]))
          let a = document.createElement('a')
          a.style.display = 'none'
          a.href = url
          a.setAttribute('download', fileName)
          document.body.appendChild(a)
          a.click() //执行下载
          window.URL.revokeObjectURL(a.href)
          document.body.removeChild(a)
        })
      },
      // 获取用户信息
      getUser(index) {
        getUser().then(res => {
          if (res.status === true) {
            this.userInfo = res.data
            // 获取年级下拉框
            if (index === 1 && !this.testunion) {
              this.getGradeList()
              this.getSchoolyear()
            } else {
              this.isActive = 2
              this.$store.state.examIsActive = 2
              this.getUnionExamList()
              this.getUnionListcontent()
            }
            let icon = res.data.schoolIcon
            if (icon) {
              this.changeFavicon(icon)
            }
          }
        })
      },
      // 更换网页icon
      changeFavicon(link) {
        let favicon = document.querySelector('link[rel="icon"]')
        if (favicon !== null) {
          favicon.href = link
        } else {
          favicon = document.createElement('link')
          favicon.rel = 'icon'
          favicon.href = link
          document.head.appendChild(favicon)
        }
      },
      // 获取年级下拉框
      getGradeList() {
        this.gradeList = [
          {
            gradeId: -1,
            gradeName: this.$t('exam.gradeList[0]')
          }
        ]
        let params = {
          schoolId: this.userInfo.schoolId
        }
        axios({
          host: 'testApi',
          url: 'getevagrade',
          params,
          loading: true
        }).then(res => {
          if (res.status) {
            this.gradeList = this.gradeList.concat(res.data)
          }
        })
      },
      getSchoolyear() {
        axios({
          host: 'baseApi',
          url: 'getschoolyearandsemester',
          loading: true
        }).then(res => {
          let schoolyearList = res.data || []
          let querySchoolYear = this.$route.query.schoolYear
          // 跳转过来回显选中学年学期
          if (querySchoolYear) {
            let arr = schoolyearList.filter(item => item.Id == querySchoolYear)
            this.form.schoolYear = arr.length
              ? +querySchoolYear
              : schoolyearList[0].Id
          }
          if (!querySchoolYear) {
            schoolyearList.forEach(item => {
              item.isCurrent && (this.form.schoolYear = item.Id)
            })
            if (!this.form.schoolYear)
              this.form.schoolYear = schoolyearList[0].Id
          }
          this.schoolyearList = schoolyearList
          this.getExamlist()
          this.getListcontent()
        })
      },
      getExamlist() {
        let params = {
          enterYear: 0,
          schoolYear: this.form.schoolYear,
          gradeId: this.form.gradeId,
          meExamType: this.form.meExamType,
          meType: this.form.meType
        }
        axios({
          url: 'examList',
          params,
          loading: true
        }).then(res => {
          if (res.status) {
            this.examList = res.data.list || []
            if (this.examList.length) {
              this.form.examId = this.examList[0].value
            }
            if (!this.examList.length) {
              this.form.examId = undefined
            }
          }
        })
      },
      //校端联考、联考获取考试名称下拉框
      getUnionExamList() {
        let url = this.testunion ? 'getexamlist' : 'getschoolexamlist'
        let params = {
          schoolId: this.userInfo.schoolId
        }
        axios({
          url: url,
          loading: true,
          params
        }).then(res => {
          if (res.status) {
            this.examList = res.data || []
            if (this.examList.length) {
              this.form.examId = this.examList[0].value
            }
            if (!this.examList.length) {
              this.form.examId = undefined
            }
          }
        })
      },
      getListcontent() {
        let params = {
          enterYear: 0,
          gradeId: this.form.gradeId,
          examId: this.form.examId || 0,
          meExamType: this.form.meExamType,
          meType: this.form.meType,
          schoolYear: this.form.schoolYear
        }
        axios({
          url: 'getreportexaminfolist',
          params,
          loading: true,
          noTip: true
        }).then(res => {
          this.notDataMsg = this.defultMsg
          if (!res.status) {
            this.notDataMsg = res.msg
          }
          if (!this.form.examId) this.form.examId = 0
          if (res.status && res.data) {
            let examInfoList = res.data || []
            this.examInfoList = examInfoList.map(item => {
              return this.TransformData(item)
            })
          } else {
            this.examInfoList = []
          }
          this.listShow = true
        })
      },
      // 更新未发布学科
      updateListcontent(item) {
        // 未发布学科
        let unpublishList = item.allSubject.filter(ele => ele.seId)
        let list = []
        // 发布学科
        let publishList = []
        item.downList.map(
          ele =>
            ele.examGroupInfoList &&
            ele.examGroupInfoList.length &&
            list.push(...ele.examGroupInfoList)
        )
        list.forEach(son => {
          // 更新未发布列表
          let index = unpublishList.findIndex(
            sonitem => sonitem.seId == son.seId
          )
          if (index != -1) {
            unpublishList.splice(index, 1)
          }
          // 更新发布列表
          let isHave = publishList.some(sonitem => sonitem.seId == son.seId)
          if (!isHave) {
            publishList.push(son)
          }
        })
        item.unPublishedCourse = unpublishList
        item.publishedCourse = publishList
        // 有未发布的学科时，快速下载中 不展示全科
        if (publishList.length && item.unPublishedCourse.length) {
          let obj = { ...item.publishedCourse[0] }
          if (!obj.seId) {
            item.publishedCourse.shift(obj)
          }
        }
      },
      getisParentData() {
        axios({
          host: 'testApi',
          url: 'getreportsettings'
        }).then(res => {
          if (res.data) {
            this.isShowToParent = res.data.isShowToParent
            this.isShowToStudent = res.data.isShowToStudent
          }
        })
      },

      TransformData(item = {}) {
        item.showgroup = false
        item.loading = false
        item.downList = []
        item.img = require('./img/title' + item.meExamType + '.png')
        let unpublishList = item.unPublishedCourse || []
        item.unPublishedCourse = unpublishList
        let publishList = item.publishedCourse || []
        item.allSubject = [...unpublishList, ...publishList]
        // 家长可见开关
        item.isSwitch = this.isActive == 2 ? item.isSwitch : item.IsSwitch
        // 有未发布的学科时，快速下载中 不展示全科
        if (publishList.length && item.unPublishedCourse.length) {
          let obj = { ...item.publishedCourse[0] }
          if (!obj.seId) {
            item.publishedCourse.shift(obj)
          }
        }
        // 联考，快速下载展示全科
        let isAll = this.isActive == 2 || this.testunion
        if (isAll && !item.unPublishedCourse.length) {
          let obj = { ...item.publishedCourse[0] }
          obj.name = this.$t('exam.allCourse')
          obj.seId = 0
          item.publishedCourse.unshift(obj)
        }
        if (item.meExamType == 0) {
          item.type = this.$t('exam.meExamType[0]')
        }
        if (item.meExamType == 1) {
          item.type = this.$t('exam.meExamType[1]')
        }
        if (item.meExamType == 2) {
          item.type = this.$t('exam.meExamType[2]')
        }
        if (item.meExamType == 3) {
          item.type = this.$t('exam.meExamType[3]')
        }
        if (item.meExamType == 4) {
          item.type = this.$t('exam.meExamType[4]')
        }
        if (item.meExamType == 5) {
          item.type = this.$t('exam.meExamType[5]')
        }
        if (item.meExamType == 6) {
          item.type = 'HKDSE'
        }

        return item
      },
      //联考、校级联考考试列表
      getUnionListcontent() {
        let url = this.testunion ? 'getexaminfolist' : 'getschoolexaminfolist'
        let params = {
          schoolId: this.userInfo.schoolId,
          meId: this.form.examId || 0
        }
        axios({
          url: url,
          params,
          loading: true,
          noTip: true
        }).then(res => {
          if (!this.form.examId) this.form.examId = 0
          if (res.status && res.data) {
            let examInfoList =
              res.data.map(item => {
                return this.TransformData(item)
              }) || []
            this.examInfoList = examInfoList
          } else {
            this.examInfoList = []
          }

          this.listShow = true
        })
      }
    }
  }
</script>
<style lang="less" scoped>
  .search_score {
    .title_text {
      font-family: PingFang SC;
      font-size: 14px;
      letter-spacing: -0.01px;
      color: #1d2129;
    }
    .line_item {
      padding: 5px 0;
      min-height: 50px;
      border-bottom: 1px solid rgba(0, 0, 0, 0.15);
      .msg_text {
        font-family: PingFang SC;
        font-size: 12px;
        line-height: 12px;

        letter-spacing: 0px;
        color: #888;
      }
    }

    .noBorder_item {
      border: none !important;
    }
    .col_right {
      text-align: right;
    }
    .link_conten {
      border-radius: 4px;
      opacity: 1;
      background: #f2f3f5;
      font-family: PingFang SC;
      font-size: 14px;
      padding: 8px;
    }

    .copy {
      font-size: 14px;
      font-weight: normal;
      letter-spacing: 0px;
      color: #3662ec;
      cursor: pointer;
    }
  }
  .contrast-form {
    .input,
    .select {
      width: 400px;
    }
  }
  /deep/.setgreadModal .ant-modal-body {
    max-height: 620px;
    overflow-y: auto;
    &:hover::-webkit-scrollbar-thumb {
      visibility: visible;
    }
  }
  .pageModule {
    width: 100%;
    height: 100%;
    background: #f9f9fa;
    display: flex;
    flex-direction: column;
    overflow-y: hidden;
    padding-right: 0;
  }
  .right {
    float: right;
  }
  header {
    width: 100%;
    height: 50px;
    background: #ffffff;
    border-bottom: 1px solid #dcdee0;
    // box-shadow: 0px -1px 0px 0px #eeeeee inset;
    // margin-bottom: 12px;
    .composite-box {
      width: 100%;
      margin: 0 auto;
      height: auto;
      display: flex;
      justify-content: flex-start;
      .tab_right {
        flex: 1;
        height: 50px;
        display: flex;
        // background: red;
        justify-content: flex-end;
        align-items: center;
        padding-right: 20px;
        border-bottom: 1px solid #dcdee0;
      }
      .composite-list {
        width: auto;
        height: 50px;
        // margin-left: 52px;
        ul {
          margin-bottom: 0;
          li {
            float: left;
            min-width: 120px;
            height: 50px;
            // padding: 14px 20px;
            border: 1px solid #dcdee0;
            border-right: none;
            text-align: center;
            font-size: 14px;
            cursor: pointer;
            color: #888888;
            line-height: 50px;
            padding: 0 29px;
            position: relative;
            &:last-child {
              border-right: 1px solid #dcdee0;
            }
          }
          .active {
            color: @primary-color;
            background: none;
            // border-bottom: 1px solid #fff;
            &::after {
              content: '';
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              height: 2px;
              background: @primary-color;
            }
            span {
              font-weight: 550;
              // position: relative;
              // &:after {
              //   content: '';
              //   position: absolute;
              //   bottom: -17px;
              //   left: 0;
              //   height: 2px;
              //   width: 100%;
              //   background: #1677ff;
              // }
            }
          }
        }
      }
    }
  }
  .pageModulehead {
    height: 48px;
    line-height: 48px;
    background: white;
    border-bottom: 1px #e5e5e5 solid;
    .title {
      float: left;
      margin-left: 20px;
      font-size: @font-size-lg;
      font-weight: 550;
      color: @text-color-secondary;
      border-bottom: 1px solid #f7f8fb;
    }
  }
  .list_content {
    width: 100%;
    flex: auto;
    padding-right: 18px;
    scrollbar-gutter: stable;
    // 这个属性设置预留滚动条的宽度所以右padding就减6px

    .content_div {
      height: 100%;
      background: #fff;
      display: flex;
      flex-direction: column;
      flex: auto;
      .search_div {
        // min-height: 64px;
        line-height: 50px;
        padding: 8px 16px;
        border-bottom: 1px solid #e5e5e5;
        background-color: #fff;
        position: relative;
        .in-bk {
          display: inline-block;
        }
        .span {
          font-size: @font-size-base;
          color: rgba(0, 0, 0, 0.85);
          margin-left: @font-size-lg;
        }
        .input {
          margin-left: 16px;
          width: 200px;
        }
        .select {
          width: 200px;
        }
        .btn {
          margin-top: 16px;
        }
      }
      .test_list {
        padding: 0 12px;
        .list_item {
          width: 100%;
          padding-top: 20px;
          min-height: 110px;
          background: linear-gradient(-166deg, #ffffff 64%, #f0f9ff 100%);
          border: 1px solid #e7e9ed;
          border-radius: 5px;
          display: flex;
          align-items: center;
          position: relative;
          margin-bottom: 12px;
          .right-tag {
            position: absolute;
            top: 0;
            right: 0;
            width: 36px;
          }
          .titleImg {
            width: 55px;
            height: 42px;
            margin-left: 20px;
            margin-right: 15px;
            margin-top: -22px;
            img {
              width: 100%;
            }
          }
          .exam_message {
            width: 100%;
            display: flex;
            justify-content: center;
            flex-direction: column;
            align-items: flex-start;

            .exam_message_all {
              padding-bottom: 1px;
              width: 100%;
              border-bottom: 1px dashed #eeeeee;
              padding-right: 12px;
              display: flex;
              justify-content: space-between;
              .title_all {
                flex: 1;
                display: flex;
                flex-direction: column;
                .all_left {
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  .xn {
                    float: left;
                    height: 22px;
                    font-size: @font-size-sm;
                    background: #e7f3ff;
                    color: @primary-color;
                    border: 1px solid #a2d1ff;
                    border-radius: 3px;
                    padding: 0 8px;
                    text-align: center;
                    line-height: 22px;
                    margin-right: 10px;
                  }
                  .title {
                    font-size: @font-size-lg;
                    font-weight: bold;
                    text-align: left;
                    color: @text-color-secondary;
                    line-height: 16px;
                  }
                }
                .all_right {
                  margin-right: 34px;
                  margin-top: 14px;
                  .subject_data {
                    display: flex;
                    align-items: center;
                    justify-content: flex-start;
                    p {
                      margin-bottom: 0;
                    }
                    .ant-divider,
                    .ant-divider-vertical {
                      background: #e5e5e5;
                      top: 0.06em;
                    }
                    span {
                      font-size: @font-size-base;
                      text-align: left;
                      color: #888888;
                      line-height: 14px;
                    }
                  }
                  .deleted_icon {
                    text-align: center;
                    line-height: 28px;
                    width: 28px;
                    height: 28px;
                    opacity: 1;
                    background: transparent;
                    border-radius: @border-radius-base;
                    position: absolute;
                    top: 6px;
                    right: 14px;
                    cursor: pointer;
                    &:hover {
                      background: #f0f0f0;
                    }
                    i {
                      color: #aaaaaa;
                    }
                  }
                }
              }
              .exam_message_all_btn {
                display: flex;
                height: 64px;
                align-items: center;
                .more-btn {
                  margin-right: 24px;
                }
                .playBtn {
                  cursor: pointer;
                  color: @text-color;
                  i {
                    vertical-align: middle;
                  }
                }
                .playBtn:hover {
                  color: @primary-color;
                }
              }
            }
            .exam_course {
              margin-top: 12px;
              width: 100%;
              display: flex;
              justify-content: space-between;
              .exam_course_subject {
                flex: 1;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1;
                .ant-btn {
                  background: #ffffff;
                  border: 1px solid #d9d9d9;
                  border-radius: 5px;
                  font-size: @font-size-base;
                  min-width: 80px;
                  height: 32px;
                  line-height: 20px;
                  margin-right: 20px;
                  margin-bottom: 12px;
                  span {
                    line-height: 14px;
                  }
                  &:hover {
                    background: #ffffff;
                    border-color: @primary-color;
                    color: @primary-color;
                  }
                  &:active {
                    background: #eaeaea;
                    border-color: #dcdee0;
                    color: #323232;
                  }
                  &:last-child {
                    margin-right: 0;
                  }
                }
              }
              .exam_course_subject2 {
                -webkit-line-clamp: 10;
              }
              .exam_course_btn {
                cursor: pointer;
                width: 85px;
                padding-right: 20px;
                text-align: right;
              }
            }
          }
          &:last-child {
            margin-bottom: 0;
          }
          &:hover {
            box-shadow: 0px 2px 14px 0px #f1f4fa;
          }
        }
      }
    }
  }
  .content-card {
    background-color: #fff;
    flex: auto;
    .test_line {
      margin: 0 @padding-lg;
      border-bottom: @border-width-base solid #eee;
    }
    /deep/ .ant-card-body {
      padding-bottom: 0;
      position: relative;
      .line_div {
        position: absolute;
        left: 0;
        top: 0;
        width: 100%;
        height: 12px;
        background: #f9f9fa;
      }
    }
    /deep/.card-list:first-child .ant-card-body {
      padding-top: 10px;
    }
    .line_title {
      display: flex;
      justify-content: space-between;
      align-items: center;
      min-height: 52px;
      border-bottom: 1px solid #e5e5e5;
      padding-bottom: 10px;
      flex-wrap: wrap;
      .title-left {
        display: flex;
        .examIcon {
          float: left;
          width: 36px;
          height: 40px !important;
        }
        .test_title {
          display: flex;
          margin-left: 23px;
          height: 40px !important;
          line-height: 40px !important;
          font-size: @font-size-lg;
          font-weight: 500;
          text-align: left;
          color: @text-color-secondary;
          .test_title_span {
            display: inline-block;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
            word-break: keep-all;
          }
        }
      }
      .title-right {
        display: flex;
        align-items: center;
        justify-content: flex-end;
        color: #888888;
      }
    }
    .line {
      height: 12px;
      width: 0;
      border-left: 1px solid #e5e5e5;
      margin-left: 12px;
      margin-right: 12px;
      margin-bottom: -1px;
      display: inline-block;
    }
    .down-menu {
      color: #888;
    }
    .content-list {
      .course_report {
        display: flex;
        padding: 20px 0;
        .course_all {
          background-color: @primary-color;
          width: 48px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          color: #fff;
          border-radius: 4px;
          font-size: @font-size-lg;
          font-weight: 400;
          cursor: pointer;
        }
        .course_name {
          width: 48px;
          height: 48px;
          line-height: 48px;
          text-align: center;
          color: #fff;
          border-radius: 4px;
          font-size: @font-size-lg;
          font-weight: 400;
          background-color: #36cfc9;
          cursor: pointer;
          position: relative;
          .icon-name {
            position: absolute;
            top: -6px;
            right: -5px;
            background: #fff;
            width: 14px;
            height: 14px;
            border-radius: 50%;
            > i {
              color: #ff9f00;
              position: absolute;
              top: 0;
              left: 0;
            }
          }
        }
        .course_lk {
          cursor: default;
        }
        .report_item {
          flex: 1;
          text-align: center;
          margin: 0 10px;
          .number {
            font-size: @font-size-lg;
            font-weight: 400;
            color: @text-color-secondary;
          }
          .title {
            font-size: @font-size-base;
            font-weight: 400;
            color: #888;
          }
          .red {
            color: #ff3b30;
          }
        }
        .edit_box {
          display: flex;
          align-items: center;
          justify-content: center;
          .edit_btn {
            width: 100%;
            border-left: 1px solid #e8e8e8;
          }
        }
      }
    }
    .type_shoole {
      min-height: 88px;
      &::after {
        content: '';
        display: block;
        clear: both;
      }
      .exam_type {
        height: 88px;
        float: left;
        .exam_type_img {
          width: 55px;
          height: 55px;
          margin: 20px 40px 0;
          img {
            width: 100%;
            height: 100%;
          }
        }
      }

      .exam_text {
        float: left;
        width: 42%;
        font-size: @font-size-base;
        font-weight: 400;
        color: @text-color-secondary;

        .line_msg {
          line-height: 30px;
          .tag {
            color: @primary-color;
            border: @border-width-base solid @primary-color;
            background-color: @secondary-color;
            border-radius: 2px;
            line-height: 18px;
            font-size: @font-size-sm;
            margin-right: 8px;
          }
          .showDown {
            cursor: pointer;
          }
          .title_exam {
            font-size: @font-size-lg;
            font-family: PingFang SC-Semibold, PingFang SC;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.85);
          }
        }
      }
      .action {
        float: right;
        text-align: right;
        padding-right: 10px;
        height: 88px;
        line-height: 88px;
        display: flex;
        .ant-col {
          display: flex;
          align-items: center;
        }
        .style-report-btn {
          margin-right: 10px;
        }
        .clear {
          margin-right: 10px;
          display: none;
        }

        .line_p {
          line-height: 22px;
          margin: 8px 0;
          cursor: pointer;
        }
        .ant-divider {
          margin: 0 16px;
        }
        .action_btn {
          margin-left: 10px;
        }
        .down_title {
          float: right;
          position: relative;
          cursor: pointer;
          height: 32px;
          line-height: 32px;
        }
      }
    }
    .groudsname {
      border: none;
      margin: 0 20px;
      /deep/.ant-card-body {
        padding: 0;
      }
      .parsing {
        max-height: 0;
        min-height: 0;
        overflow: hidden;
        transition: all 0.3s;
      }
      .parsingShow {
        min-height: 70px;
      }
    }
    .groudsname.topline {
      border-top: @border-width-base dashed #eee;
      /deep/.ant-card-body {
        padding: 20px 0;
      }
    }
    .sun_item {
      // padding-bottom: @padding-lg;
      .groud_name {
        line-height: 30px;
        height: 30px;
        text-align: left;
        padding-left: 40px;
        font-size: @font-size-lg;
        font-weight: 600;
        color: @text-color-secondary;
        .down-menu {
          font-size: 14px;
          font-weight: 400;
          cursor: pointer;
        }
      }

      .sun_item_line {
        padding: @padding-lg 0;
        padding-top: 10px;
        height: 80px;
        line-height: 25px;
        text-align: center;
        // border: 1px red solid;
        display: flex;
        align-items: center;
        .subject_name {
          width: 40px;
          height: 40px;
          border-radius: 4px;
          background-color: #497dff;
          line-height: 40px;
          text-align: center;
          color: white;
          margin-left: 50px;
          cursor: pointer;
          overflow: hidden;
        }
        .onesubject {
          background-color: #36cfc9;
        }
        .number_msg {
          font-weight: 600;
          color: @text-color-secondary;
          font-size: 18px;
        }
        .red {
          color: red;
        }
        .text_msg {
          font-size: @text-color-secondary;
          font-size: @font-size-sm;
        }
      }
    }
  }
  /deep/ .tag_modal .ant-modal-body {
    padding: 0;
    max-height: 55vh;
    overflow-y: auto;
    &:hover::-webkit-scrollbar-thumb {
      visibility: visible;
    }
    .modal-content {
      padding: @padding-lg;
    }
    .input-val {
      width: 100%;
    }
  }
  .settingScore {
    cursor: pointer;
  }
  .modal-desc {
    color: #888;
    font-size: @font-size-sm;
    margin-left: 5px;
  }
  .tag_box {
    margin-left: 60px;
    margin-top: 24px;
    .tag_span {
      font-size: @font-size-base;
      float: left;
      height: 22px;
      margin-right: 40px;
      padding: 1px 8px;
      border-radius: @border-radius-base;
      cursor: pointer;
    }
  }
  /deep/ .tag_modal {
    .ant-modal {
      height: 88%;
    }
    .ant-modal-content {
      height: 100%;
      display: flex;
      flex-direction: column;
    }
    .ant-modal-body {
      max-height: 2000px;
      flex: 1;
    }
  }
  /deep/ .ant-modal-title {
    margin-right: 14px;
  }
  .tacTicBack,
  .returnBack {
    background: linear-gradient(90deg, #f3f8ff 0%, #edf2ff 100%);
    color: #497dff;
  }
  .tacTicSave {
    background: linear-gradient(90deg, #497dff 0%, #86b4ff 100%);
    color: white;
  }
  .noActive {
    background: #ffffff;
    border: #4a62e7 1px solid #4a62e7;
    color: @primary-color;
  }
  .active {
    background: @primary-color;
    color: #fff;
  }
  .deActive {
    background: rgba(60, 100, 239, 0.1);
    color: @primary-color;
  }
  .report_cot {
    width: 100%;
  }
  /deep/.ant-checkbox-wrapper + .ant-checkbox-wrapper {
    margin-left: 0;
    margin-bottom: 10px;
  }
  /deep/.ant-select-tree-dropdown {
    &:hover::-webkit-scrollbar-thumb {
      visibility: visible;
    }
  }
</style>
